var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, customElement, property, html, css } from 'lit-element';
let QueueElement = class QueueElement extends LitElement {
    getActualHourlyOperations(terminalType, queueStatistics) {
        if (terminalType == "Aktualisierer") {
            return queueStatistics.validated;
        }
        else if (terminalType == "Ausgabeautomat") {
            return queueStatistics.issued;
        }
        else
            return 30;
    }
    getMaxHourlyOperations(terminalType) {
        // queues are longer at issuers since they're slower
        if (terminalType == "Aktualisierer") {
            return 120;
        }
        else if (terminalType == "Ausgabeautomat") {
            return 60;
        }
        else
            return 30;
    }
    render() {
        const actualHourlyOperations = this.getActualHourlyOperations(this.terminalType, this.queueStatistics);
        const maxHourlyOperations = this.getMaxHourlyOperations(this.terminalType);
        const terminalUtilization = actualHourlyOperations / maxHourlyOperations;
        const queueLength = 5;
        const opaqueSilhouettes = terminalUtilization * queueLength;
        let queueTemplate = [];
        for (let i = 0; i < queueLength; i++) {
            if (i < opaqueSilhouettes) {
                queueTemplate.push(html `<img src="littleperson.png">`);
            }
            else {
                queueTemplate.push(html `<img src="littleperson.png" class="transparent">`);
            }
        }
        return html `${queueTemplate}`;
    }
};
QueueElement.styles = css `.transparent { opacity: 0.2; }`;
__decorate([
    property()
], QueueElement.prototype, "queueStatistics", void 0);
__decorate([
    property()
], QueueElement.prototype, "terminalType", void 0);
QueueElement = __decorate([
    customElement('x-queue')
], QueueElement);
export { QueueElement };
